const ChevronDown = () => (
  <svg focusable={false} viewBox='0 0 16 17'>
    <path d='M11.646 6.646a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L8 10.293l3.646-3.647z' />
  </svg>
);

export default ChevronDown;
